module.exports = __webpack_public_path__ + "static/media/logo-lojas-renner.922fae1e.svg";